module.exports = __webpack_public_path__ + "imgascvts/bolan.7245b912.png";